import { createSelector } from 'reselect';
import { ERROR_FETCH_CARD_LIST } from '../actions/deletePrimaryCard';
import { ICard } from '../types/Card';
import { DemoViewMode } from '../types/DemoViewMode';
import { IStoreState } from '../types/StoreState';
import { selectDeletePrimaryCardState, selectDemoViewMode, selectViewMode } from './appState';
import { selectExpandedCardId } from './ui';

const selectMarkCardPrimaryState = (state: IStoreState) => state.requestsState.markCardPrimary;
const selectFetchState = (state: IStoreState) => state.requestsState.fetchCards;
export const selectFailedMarkPrimaryCardId = (state: IStoreState) => state.requestsState.markCardPrimary.creditCardId;
const selectCards = (state: IStoreState): ICard[] => state.domain.cards;
const selectDemoCards = (state: IStoreState): ICard[] => state.domain.demoCards;
export const selectCardList = createSelector(
  selectViewMode,
  selectDemoViewMode,
  selectCards,
  selectDemoCards,
  (viewMode, demoViewMode, cards, demoCards) =>
    viewMode === 'site' ? cards : demoViewMode === DemoViewMode.WithCards ? demoCards : [],
);
export const selectPrimaryCard: (state: IStoreState) => ICard = createSelector(selectCardList, (cards) =>
  cards.find((card) => card.primary),
);
export const selectExpandedCard = createSelector(selectCardList, selectExpandedCardId, (cards, expandCardId) =>
  cards.find((card) => card.creditCardId === expandCardId),
);

export const selectCardsListEmpty = createSelector(selectCardList, (cardsList) => cardsList.length === 0);

export const selectFetchCardStatusFailed = createSelector(
  selectFetchState,
  selectDeletePrimaryCardState,
  (fetchState, deletePrimary) => {
    return !!fetchState.error || deletePrimary.error === ERROR_FETCH_CARD_LIST;
  },
);

export const selectMarkCardPrimaryCardId = createSelector(
  selectMarkCardPrimaryState,
  (markCardPrimaryState) => markCardPrimaryState.creditCardId,
);
